import { makeInstaller } from '@vuemap/vue-amap-util'
import Components from './component'

export default makeInstaller([...Components])
